import React from "react";
import { GeoJSON, Popup } from "react-leaflet";

// NOAA NDGD surface smoke density classes (µg/m³) -> smoke-gray styling
const CLASS_STYLE = {
  "3 - 25":     { color: "#9CA3AF", fillColor: "#9CA3AF", weight: 0.8, fillOpacity: 0.18 },
  "25 - 63":    { color: "#6B7280", fillColor: "#6B7280", weight: 0.8, fillOpacity: 0.28 },
  "63 - 158":   { color: "#4B5563", fillColor: "#4B5563", weight: 0.8, fillOpacity: 0.38 },
  "158 - 1000": { color: "#1F2937", fillColor: "#1F2937", weight: 1,   fillOpacity: 0.5 },
};

export default function SmokeLayer({ smoke }) {
  const features = smoke?.features || [];
  if (!features.length) return null;
  const validAt = smoke.valid_at
    ? new Date(smoke.valid_at).toLocaleString(undefined, {
        month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
      })
    : null;

  return features.map((f, i) => {
    const cls = f.properties?.smoke_classdesc || "3 - 25";
    const style = CLASS_STYLE[cls] || CLASS_STYLE["3 - 25"];
    return (
      <GeoJSON
        key={`smoke-${f.id ?? f.properties?.OBJECTID ?? i}`}
        data={f}
        style={() => style}
      >
        <Popup>
          <div className="min-w-[190px]" data-testid="smoke-popup">
            <div className="text-[10px] font-bold uppercase tracking-wider mb-1 text-tac-dim">
              NOAA Surface Smoke
            </div>
            <div className="font-display font-bold text-sm text-tac-text mb-1">
              {cls} µg/m³
            </div>
            {validAt && (
              <div className="text-[11px] text-tac-dim font-mono-tac">Forecast valid {validAt}</div>
            )}
            <div className="text-[10px] font-mono-tac text-tac-faint mt-2 pt-1 border-t border-tac-border/60">
              Source: NOAA NDGD via AirNow smoke data
            </div>
          </div>
        </Popup>
      </GeoJSON>
    );
  });
}
